import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import Grid from './v3/ui/Grid.vue'
// const route = useRoute()

export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

// import { useRoute } from 'vue-router'

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Grid))
}
}

})